import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppMaterialModule } from "./app-material.module";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SecureLayoutComponent } from "./layouts/secure/secure-layout/secure-layout.component";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { StoreModule } from "@ngrx/store";
import { appReducer } from "./app.reducer";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { EffectsModule } from "@ngrx/effects";
import { AuthEffects } from "./shared/auth/auth.effects";
import { LoadingIndicatorComponent } from "./shared/loading-indicator/loading-indicator.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { BidaSvgComponent } from "./shared/components/bida-svg/bida-svg.component";
import { CustomInterceptor } from "./shared/api/custom.interceptor";
import { appInitProvider } from "./app-init";
import { AuthInterceptor } from "./shared/api/auth.interceptor";
import { CSRFInterceptor } from "./shared/api/csrf.interceptor";
import { designSystemInitProvider } from "./shared/components/bd-templates/design-system-init";
import { AvatarInitialsComponent } from "./shared/components/avatar-initials/avatar-initials.component";
import { environment } from "../environments/environment";

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    // AppMaterialModule,
    BrowserModule,
    // ReactiveFormsModule,
    ScrollingModule,
    AppRoutingModule,
    // NoopAnimationsModule,
    StoreModule.forRoot(appReducer),
    EffectsModule.forRoot([AuthEffects]),
    // StoreDevtools: logOnly in production (no state mutation), full in dev
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    LoadingIndicatorComponent,
    BidaSvgComponent,
    AvatarInitialsComponent,
  ],
  providers: [
    // ActivityApiService,
    // DatePipe,
    appInitProvider,
    designSystemInitProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      // CSRF Protection - adds X-CSRF-Token header to state-changing requests
      provide: HTTP_INTERCEPTORS,
      useClass: CSRFInterceptor,
      multi: true,
    },
    // provideStore({
    //   auth: authReducer,
    //   // auth: fromApp.authReducer,
    // }),
    // provideEffects([AuthEffects]),
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ApiInterceptor,
    //   multi: true
    // },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
  ],
})
export class AppModule { }
